import { Divider, Grid } from '@mui/material';
import React from 'react';

const ModelViewerLine = () => {
  return (
    <Grid item md={12} marginTop={2} marginBottom={1}>
      <Divider sx={{ background: '#ddd' }} />
    </Grid>
  );
};

export default ModelViewerLine;
